import { authPost } from "../../common/redux/ApiClient";

const baseUrl = "http://35.240.204.237/ok99memberApi/api";

export function fetchFishingGameList(params, signal) {
  return authPost(`${baseUrl}/MemberMobile2/MbFishingGameList`, params, signal);
}

export function companyPlayGame(params, signal) {
  return authPost(`${baseUrl}/Member3/CompanyPlayGame`, params, signal);
}
